// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/image/logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,500;0,700;1,300;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,500;1,300;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-stile-section {
  display: flex;
  align-items: center;
  width: 430px;
  height: 550px;
  flex-direction: column;
  background: #212121;
  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  margin: calc(0% + 10%) calc(55% - 15%) 0 calc(20% + 15%);
}

.img-logo {
  margin: 76px 0 66px 0;
  padding: 40px;
  color: #ebce2c;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
}

.login-stile-form {
  display: flex;
  flex-direction: column;
  background: none;
  background: rgba(217, 217, 217, 0.05);
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0);
  border-radius: 10px;
  margin-bottom: 30px;
  padding: 0.2rem 1.6rem;
}

.login-stile-label {
  font-size: 14px;
  font-family: Ubuntu;
  font-weight: 300;
  letter-spacing: 0.8px;
  color: #ebce2c;
  margin-bottom: 4px;
}

.login-stile-input {
  display: flex;
  flex-wrap: wrap;
  background: none;
  font-size: 14px;
  font-family: Ubuntu;
  letter-spacing: 0.7px;
  font-weight: 300;
  color: #cccccc;
}

.login-stile-input[type="text"],
.login-stile-input[type="password"],
.login-stile-button [type="button"] {
  text-indent: 10px;
  letter-spacing: 0.5px;
  color: #cccccc;
}

input:focus,
input:active,
input:not(:focus) {
  outline: none;
  border: none;
  background: transparent;
  color: #cccccc;
  font-family: Ubuntu;
  letter-spacing: 0.7px;
  text-indent: 7px;
}

.login-stile-button {
  color: #181818;
  font-size: 20px;
  font-family: Ubuntu;
  font-weight: 700;
  letter-spacing: 1.1px;
  padding: 0.3rem 0;
  background: #ebce2c;
  border-radius: 35px;
  outline: none;
  border: none;
  margin-top: 10px;
}

.login-stile-button:hover:not(:active) {
  box-shadow: 0px 1px 2px 0px rgba(81, 107, 177, 0.966),
    2px 2px 8px 0px rgba(108, 128, 182, 0.966);
}

.login-stile-button:hover,
.login-stile-button:not(:focus) {
  outline: none;
  border: none;
}

.login-stile-button:focus,
.login-stile-button:active {
  outline: none;
  border: none;
}

.error-notification {
  position: fixed;
  margin: 180px 5.2em;
  color: #ff6666;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  text-align: center;
}
.offscreen{
    display: none;
    color: #47c752;
  
}
.msg-notification {
    position: fixed;
    margin: 180px 5.2em;
    color: #47c752;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 999;
    display: flex;
    text-align: center;
  }

.login-stile-a {
  margin-top: 20px;
  display: block;
  text-align: center;
  color: #ebce2c;
  box-shadow: none;
}
.login-stile-a:hover {
  text-decoration: underline;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,yDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;8CAC4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;IACI,aAAa;IACb,cAAc;;AAElB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;AAEF;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,500;0,700;1,300;1,700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,500;1,300;1,700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;1,700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\");\n\n.login-stile-section {\n  display: flex;\n  align-items: center;\n  width: 430px;\n  height: 550px;\n  flex-direction: column;\n  background: #212121;\n  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);\n  border-radius: 20px;\n  margin: calc(0% + 10%) calc(55% - 15%) 0 calc(20% + 15%);\n}\n\n.img-logo {\n  margin: 76px 0 66px 0;\n  padding: 40px;\n  color: #ebce2c;\n  background-image: url(../../assets/image/logo.svg);\n  background-size: 100% 100%;\n}\n\n.login-stile-form {\n  display: flex;\n  flex-direction: column;\n  background: none;\n  background: rgba(217, 217, 217, 0.05);\n  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0);\n  border-radius: 10px;\n  margin-bottom: 30px;\n  padding: 0.2rem 1.6rem;\n}\n\n.login-stile-label {\n  font-size: 14px;\n  font-family: Ubuntu;\n  font-weight: 300;\n  letter-spacing: 0.8px;\n  color: #ebce2c;\n  margin-bottom: 4px;\n}\n\n.login-stile-input {\n  display: flex;\n  flex-wrap: wrap;\n  background: none;\n  font-size: 14px;\n  font-family: Ubuntu;\n  letter-spacing: 0.7px;\n  font-weight: 300;\n  color: #cccccc;\n}\n\n.login-stile-input[type=\"text\"],\n.login-stile-input[type=\"password\"],\n.login-stile-button [type=\"button\"] {\n  text-indent: 10px;\n  letter-spacing: 0.5px;\n  color: #cccccc;\n}\n\ninput:focus,\ninput:active,\ninput:not(:focus) {\n  outline: none;\n  border: none;\n  background: transparent;\n  color: #cccccc;\n  font-family: Ubuntu;\n  letter-spacing: 0.7px;\n  text-indent: 7px;\n}\n\n.login-stile-button {\n  color: #181818;\n  font-size: 20px;\n  font-family: Ubuntu;\n  font-weight: 700;\n  letter-spacing: 1.1px;\n  padding: 0.3rem 0;\n  background: #ebce2c;\n  border-radius: 35px;\n  outline: none;\n  border: none;\n  margin-top: 10px;\n}\n\n.login-stile-button:hover:not(:active) {\n  box-shadow: 0px 1px 2px 0px rgba(81, 107, 177, 0.966),\n    2px 2px 8px 0px rgba(108, 128, 182, 0.966);\n}\n\n.login-stile-button:hover,\n.login-stile-button:not(:focus) {\n  outline: none;\n  border: none;\n}\n\n.login-stile-button:focus,\n.login-stile-button:active {\n  outline: none;\n  border: none;\n}\n\n.error-notification {\n  position: fixed;\n  margin: 180px 5.2em;\n  color: #ff6666;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  z-index: 999;\n  display: flex;\n  text-align: center;\n}\n.offscreen{\n    display: none;\n    color: #47c752;\n  \n}\n.msg-notification {\n    position: fixed;\n    margin: 180px 5.2em;\n    color: #47c752;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n    display: flex;\n    text-align: center;\n  }\n\n.login-stile-a {\n  margin-top: 20px;\n  display: block;\n  text-align: center;\n  color: #ebce2c;\n  box-shadow: none;\n}\n.login-stile-a:hover {\n  text-decoration: underline;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
